import { initializeApp } from 'firebase/app'
import firebase from 'firebase/compat/app'
import { getDatabase, get as getFirebaseItem, ref } from 'firebase/database'
import { getAnalytics, logEvent, setConsent } from 'firebase/analytics'
import 'firebase/storage'
import { getFirestore } from 'firebase/firestore'
import { getEnv } from '@constants'

const firebaseConfig = {
  apiKey: getEnv('FIREBASE_apiKey'),
  authDomain: getEnv('FIREBASE_authDomain'),
  databaseURL: getEnv('FIREBASE_databaseURL'),
  projectId: getEnv('FIREBASE_projectId'),
  storageBucket: getEnv('FIREBASE_storageBucket'),
  messagingSenderId: getEnv('FIREBASE_messagingSenderId'),
  appId: getEnv('FIREBASE_appId'),
  measurementId: getEnv('FIREBASE_measurementId'),
}

const app = initializeApp(firebaseConfig)
const db = getDatabase(app)

export const get = async (query) => (await getFirebaseItem(query)).toJSON()
export const dbRef = (path) => ref(db, path)
export const firestore = getFirestore(app)
setConsent({
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  ad_storage: 'granted',
  analytics_storage: 'granted',
})
export const logGoogleEvent = (event, data = {}) => {
  const analytics = getAnalytics()
  logEvent(analytics, event, data)
}

export default firebase
